import React, { Component } from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import { getUserRank } from 'common/api'
import styles from './rank.css'
import goldPNG from './gold.png'
import silverPNG from './silver.png'
import copperPNG from './copper.png'

const USER_RANK = [
  <img src={ goldPNG } alt="gold" />,
  <img src={ silverPNG } alt="silver" />,
  <img src={ copperPNG } alt="copper" />
]

@observer
export default class Rank extends Component {
  @observable users = []

  componentDidMount () {
    getUserRank()
      .then(action('getUserRank end', data => {
        this.users = data
      }))
  }

  renderItem (item, idx) {
    return (
      <div key={ item.userId } className={ styles.item }>
        <div className={ styles.itemIdx }>{ USER_RANK[idx] || idx + 1 }</div>
        <img className={ styles.itemAvatar } src={ item.avatar } alt={ item.nickname } />
        <div className={ styles.itemNickname }>{ item.nickname }</div>
        <div className={ styles.itemNumber }>{ item.finishedNum }题</div>
      </div>
    )
  }

  render () {
    return (
      <div className={ styles.root }>
        <div className={ styles.title }>练习排行榜</div>
        <div className={ styles.hr }></div>
        <div className={ styles.list }>
          { this.users.map(this.renderItem) }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Aside/Rank.js
 **/